export function loadBMap(funcName) {
    var script = document.createElement("script");
    script.src = "https://api.map.baidu.com/api?v=2.0&ak=KCzp8claYra8uYAvahElV9oKUT6j7Gx1&callback=" + funcName;
    document.body.appendChild(script);
}